// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './assets/css/reset.css'
import './assets/css/public.css'
import 'element-ui/lib/theme-chalk/index.css'

import 'swiper/dist/css/swiper.min.css'
import './assets/css/el_entstyle.scss'
import router from './router'
import axiosPlugin, {
  baseURL
} from './server'
import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
import {
  Message,
  MessageBox,
  Loading
} from 'element-ui'

Object.defineProperties(Vue.prototype, {
  echarts: {
    get: () => echarts
  }
})

echarts.registerMap('china', china)

Vue.use(Loading)
Vue.use(axiosPlugin)

Vue.prototype.baseURL = baseURL
Vue.prototype.commonapi = '/commonapi'

Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm

Vue.prototype.userInfo = {}

// 上传地址
Vue.prototype.action = 'https://upload-z2.qiniup.com'

Vue.config.productionTip = false

// 退出登录
Vue.prototype.logout = function () {
  this.$confirm('是否确认退出登录？', '确认信息', {
    distinguishCancelAndClose: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  }).then(() => {
    this.$http({
      method: 'GET',
      url: '/login/logout'
    }).then(res => {
      // if (res.code === 100) {
      // removeCookie('token') // 清除token
      this.$router.push({
        path: '/login'
      })
      // }
    }).catch(error => {
      console.log(error)
      return false
    })
  })
}

console.log = (function () {
  let log = console.log
  let host = window.location
  return function () {
    if (host.protocol === 'http:') {
      log.apply(this, arguments)
    }
  }
})()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js